import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { type WorkflowProgress } from "../../../zodios/apiDefinitions/workflows";

export const useWorkflowProgress = (
  trackingId: string | undefined,
  options?: {
    refetchInterval?: number;
    enabled?: boolean;
    keepPollingWhenFinished?: (data: WorkflowProgress) => boolean;
  },
) =>
  useQuery({
    queryKey: [{ endpoint: "/api/workflows/:trackingId/progress", params: { trackingId } }],
    queryFn: async () => await apiClient.getWorkflowProgress({ params: { trackingId: trackingId! } }),
    enabled: (options?.enabled ?? true) && !!trackingId,
    refetchInterval: (query) => {
      const data = query.state.data;
      const status = data?.status;
      if ((status === "SUCCESS" || status === "FAILED") && !(data && options?.keepPollingWhenFinished?.(data))) {
        return false;
      }
      return options?.refetchInterval ?? false;
    },
  });
